module.exports = __webpack_public_path__ + "static/img/20211211_5.86a75fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2021/20211211_5.png
// module id = B3Rg
// module chunks = 0